// Sprint 17 A1: Hook for "Here's Your Money" daily view
// Wire to GET /crm/intelligence/today — prioritized deals + tasks
import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "@/lib/api-client";

export interface PrioritizedDeal {
  id: string;
  title: string;
  contactName: string;
  contactId: string;
  contactPhone?: string;
  contactEmail?: string;
  value: number;
  currency: string;
  probability: number;
  score: number;
  momentumDirection: "accelerating" | "stable" | "decelerating";
  momentumScore: number;
  section: "close_today" | "follow_up" | "new_leads" | "overdue";
  daysSinceLastActivity: number;
  nextAction?: string;
  nextActionConfidence?: number;
  createdAt: string;
}

export interface TodayIntelligence {
  closingToday: PrioritizedDeal[];
  followUp: PrioritizedDeal[];
  newLeads: PrioritizedDeal[];
  overdue: PrioritizedDeal[];
}

export function useCrmToday() {
  const [data, setData] = useState<TodayIntelligence | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(() => {
    setIsLoading(true);
    apiFetch<{ data: TodayIntelligence }>("/crm/intelligence/today")
      .then((res) => setData(res.data))
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load"))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading, error, refetch: fetchData };
}
